const technologyData = [
    { name: 'HTML', image: './images/logos/HTML.png' },
    { name: 'CSS', image: './images/logos/CSS.png' },
    { name: 'Sass', image: './images/logos/Sass.svg' },
    { name: 'JavaScript', image: './images/logos/javascript.svg' },
    { name: 'NodeJS', image: './images/logos/nodejs.png' },
    { name: 'React', image: './images/logos/react.svg' },
    { name: 'Express', image: './images/logos/express.svg' },
    { name: 'Git', image: './images/logos/git.svg' },
  ];

  export default technologyData;